import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { RatingContext } from './qualityAnalysis'
import i18n from 'live/services/i18n'
interface IProps {
    ratingType: keyof RatingInfo
    setShowDialog: Dispatch<SetStateAction<boolean>>
}
export function RatingBoxDeviationInfo({ ratingType, setShowDialog }: IProps): JSX.Element {
    const { ratingInfo } = useContext(RatingContext)
    const [deviationsInfo, setDeviationsInfo] = useState({})

    useEffect(() => {
        if (ratingInfo[ratingType].deviations.allDeviations.size) {
            setDeviationsInfo(getDeviationsInfo(ratingType, ratingInfo))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ratingInfo])

    if (!ratingInfo[ratingType].deviations.allDeviations.size) return null

    return (
        <StyledRatingBoxDeviationInfo className={`RatingBoxDeviationInfo`}>
            <div className="RatingBoxDeviationInfo--deviations">
                {Object.keys(deviationsInfo).map((packager, index) => {
                    return (
                        <span key={packager}>
                            {`${index ? ' | ' : ''} ${i18n(packager)}: `}
                            <strong>{[...deviationsInfo[packager]].join(', ')}</strong>
                        </span>
                    )
                })}
            </div>
            <i className="far fa-edit" onClick={() => setShowDialog(true)} />
        </StyledRatingBoxDeviationInfo>
    )
}

const StyledRatingBoxDeviationInfo = styled.div`
    background: ${({ theme }) => theme['gray-200']};
    color: ${({ theme }) => theme['gray-600']};
    padding: 15px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
        color: ${({ theme }) => theme['blue-500']};
        cursor: pointer;
    }
    .RatingBoxDeviationInfo {
        &--deviations {
            text-transform: capitalize;
            font-size: 13px;
        }
    }
`
export function getDeviationsInfo(ratingType: keyof RatingInfo, ratingInfo: RatingInfo): Record<string, Set<string>> {
    if (ratingType === 'packaging') {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { allDeviations, ...packagersInfo } = ratingInfo[ratingType].deviations

        return packagersInfo
    } else {
        return { deviations: ratingInfo[ratingType].deviations.allDeviations }
    }
}
